// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__-sJnv","main-content":"Layout_main-content__b7qtz","nav-hide":"Layout_nav-hide__i57bO"};